module.exports = __webpack_public_path__ + "static/media/6.e659a7dc.jpg";